import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { IonRouterOutlet } from '@ionic/angular/standalone';

@Component({
  selector: 'homi-secondary-menu-bar',
  templateUrl: 'secondary-menu-bar.component.html',
  styleUrls: ['secondary-menu-bar.component.scss'],
  imports: [IonRouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.menu-bar-disabled]': 'disabled()',
  },
})
export class SecondaryMenuBarComponent {
  public readonly disabled: InputSignal<boolean> = input(false);
}
